import Page from "../../components/Page";
import useDiagnosesList from "./hooks/useDiagnosesList";

const DiagnosesList = () => {
  const page = useDiagnosesList();
  return <Page {...page} />;
};

export default DiagnosesList;
